<template>
    <div class="menu-control">
        <div class="menu-control__item">
            <div class="button-control">
                <svg class="plus-icon" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 11.8137H21.6576" stroke-width="1.5" />
                    <path d="M10.8289 0.984863L10.8289 22.6424" stroke-width="1.5" />
                </svg>
            </div>
        </div>
        <div class="menu-control__item">
            <div class="button-control" @click.prevent.stop="onSearchClick">
                <svg class="search-icon" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10.0328" cy="10.0294" r="8.2945" stroke-width="1.5" />
                    <path d="M15.8472 15.8438L21.6615 21.6581" stroke-width="1.5" />
                </svg>
            </div>
        </div>
        <div class="menu-control__item">
            <div class="button-control" @click.prevent.stop="onAddMenuClick">
                <svg class="gear-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M19.7411 9.21716L19.8633 9.61482L20.2747 9.67687L22.9728 10.0839V13.2714L20.2603 13.6761L19.865 13.7351L19.7334 14.1126C19.5708 14.5789 19.4009 14.9941 19.1808 15.3873L18.9775 15.7506L19.2171 16.091C19.745 16.841 20.3011 17.5132 20.8554 18.178C20.6576 18.4235 20.1098 19.0291 19.5297 19.5976C19.2214 19.8997 18.9203 20.175 18.673 20.3705C18.5673 20.4541 18.4814 20.515 18.4163 20.5555L16.332 18.9474L16.0005 18.6916L15.6275 18.8818C15.2126 19.0934 14.7692 19.2766 14.3278 19.417L13.9206 19.5465L13.8712 19.9708C13.858 20.0848 13.845 20.1983 13.8322 20.3113C13.7404 21.118 13.6513 21.901 13.4607 22.631H10.1973L9.78292 19.9464L9.72038 19.5412L9.32967 19.417C8.88107 19.2743 8.45395 19.1053 8.04534 18.897L7.67841 18.7099L7.34861 18.9566L5.21301 20.5543C5.18023 20.5251 5.14719 20.4956 5.11394 20.4659C4.32304 19.7606 3.40924 18.9456 2.84173 18.1926C3.06787 17.8924 3.30313 17.5969 3.54559 17.2924C3.56682 17.2657 3.58811 17.2389 3.60945 17.2121C3.88225 16.8693 4.16268 16.5151 4.43271 16.1471L4.68004 15.8101L4.48172 15.442C4.23821 14.9901 4.04161 14.5314 3.90259 14.0654L3.78186 13.6607L3.36395 13.6L0.669271 13.208V10.0189L3.38124 9.61645L3.78985 9.5558L3.91467 9.16203C4.05418 8.72192 4.23663 8.30539 4.46581 7.88177L4.6629 7.51746L4.42121 7.18107C3.89851 6.45358 3.34853 5.77402 2.79218 5.10594C2.9868 4.85956 3.53043 4.2577 4.11168 3.68991C4.4197 3.38902 4.72058 3.11523 4.9677 2.92097C5.06814 2.84202 5.15063 2.78342 5.21447 2.74328L7.31241 4.34694L7.64342 4.59997L8.01459 4.41069C8.42944 4.19915 8.87288 4.01592 9.31432 3.87553L9.72148 3.74604L9.77087 3.32165C9.78415 3.20759 9.79709 3.09391 9.80997 2.9807C9.90175 2.17417 9.99083 1.39135 10.1814 0.661458H13.4447L13.8591 3.34608L13.9217 3.75127L14.3124 3.87553C14.761 4.0182 15.1881 4.18717 15.5967 4.39553L15.9623 4.58193L16.2917 4.33724L18.4446 2.73785C18.512 2.79909 18.5802 2.86102 18.6492 2.92356C19.4121 3.61571 20.2571 4.38232 20.7951 5.1069C20.5705 5.40468 20.3371 5.69795 20.0965 6.00012C20.0753 6.0268 20.054 6.05355 20.0326 6.08038C19.7598 6.42318 19.4794 6.77738 19.2094 7.14539L18.962 7.48245L19.1604 7.85048C19.4041 8.30281 19.6016 8.76332 19.7411 9.21716ZM18.3296 20.6025C18.3296 20.6024 18.3317 20.6015 18.3358 20.6001C18.3316 20.602 18.3296 20.6026 18.3296 20.6025ZM5.31099 2.69038C5.31094 2.69049 5.3089 2.69139 5.30499 2.69272C5.30907 2.69094 5.31103 2.69027 5.31099 2.69038ZM11.821 16.1898C14.3463 16.1898 16.4202 14.1586 16.4202 11.6463C16.4202 9.13391 14.3463 7.10271 11.821 7.10271C9.29577 7.10271 7.22185 9.13392 7.22185 11.6463C7.22185 14.1586 9.29577 16.1898 11.821 16.1898Z"
                            stroke-width="1.5" />
                </svg>
            </div>
        </div>
        <div class="menu-control__item">
            <div class="button-control" @click.prevent.stop="onLogOutClick">
                <svg class="exit-icon" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.49512 1H19.6846V24.2191H5.49512" stroke-width="1.5" />
                    <path
                        d="M0.980469 12.609H13.235M13.235 12.609L8.20419 7.44922M13.235 12.609L8.20419 17.7688"
                            stroke-width="1.5" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'the-menu-controls',
  methods: {
    onSearchClick () {
      this.$emit('search-toggle')
    },
    onAddMenuClick () {
      this.$emit('add-menu-toggle')
    },
    onLogOutClick () {
      this.$emit('log-out')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/css/system/_vars';
  @import '../../assets/css/system/_mixins';

    .menu-control {
        display: flex;
        flex-direction: row;
        border-top: 3px solid $color_second-border;

        &__item {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 65px;
            padding-top: 20px;
            padding-bottom: 20px;
        }
    }

    .button-control {
        color: $color_controls;
        cursor: pointer;
        user-select: none;
        transition: .3s;

        &:hover {
            color: $color_second-light;
        }

        &:active {
            color: $color_controls-click;
        }
    }
</style>
